
import { bindActionCreators } from 'redux';
import { connect }            from 'react-redux';
import * as actions           from '../../redux/modules/actions';
import Notifications          from './Notifications';

const mapStateToProps = (state) => {
  return {
    currentView:  state.views.currentView
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions : bindActionCreators(
      {
        enterNotifications: actions.enterNotifications,
        leaveNotifications: actions.leaveNotifications
      },
      dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Notifications);



// WEBPACK FOOTER //
// ./src/app/views/notifications/index.js